var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.5 0.5V16.5M0.5 8.5H16.5","stroke-width":"3","stroke-linecap":"square"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }